import React from 'react';
import Image from '../../../components/AppImage';

import Button from '../../../components/ui/Button';

const AnnualReportCard = ({ report }) => {
  return (
    <div className="bg-card rounded-xl overflow-hidden card-shadow hover:card-shadow-hover transition-smooth">
      <div className="relative h-48 overflow-hidden">
        <Image
          src={report.coverImage}
          alt={`${report.year} Annual Report Cover`}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        <div className="absolute bottom-4 left-4 text-white">
          <h3 className="text-xl font-bold">{report.year}</h3>
          <p className="text-sm opacity-90">Annual Impact Report</p>
        </div>
      </div>

      <div className="p-6">
        <div className="space-y-4 mb-6">
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Projects Completed</span>
            <span className="font-semibold text-foreground">{report.projectsCompleted}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Total Beneficiaries</span>
            <span className="font-semibold text-foreground">{report.beneficiaries}</span>
          </div>
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Volunteer Hours</span>
            <span className="font-semibold text-foreground">{report.volunteerHours}</span>
          </div>
        </div>

        <div className="space-y-3">
          <Button
            variant="default"
            fullWidth
            iconName="Download"
            iconPosition="left"
            className="hero-gradient"
          >
            Download Report
          </Button>
          <Button
            variant="outline"
            fullWidth
            iconName="Eye"
            iconPosition="left"
          >
            View Online
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnnualReportCard;